import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=f142375a&scoped=true"
import script from "./Question.vue?vue&type=script&lang=js"
export * from "./Question.vue?vue&type=script&lang=js"
import style0 from "./Question.vue?vue&type=style&index=0&id=f142375a&prod&lang=scss&scoped=true"
import style1 from "./Question.vue?vue&type=style&index=1&id=f142375a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f142375a",
  null
  
)

export default component.exports